import { render } from "./NftMedia.vue?vue&type=template&id=3257d4dc&scoped=true"
import script from "./NftMedia.vue?vue&type=script&lang=js"
export * from "./NftMedia.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftMedia.scss?vue&type=style&index=0&id=3257d4dc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3257d4dc"]])

export default __exports__